// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  key: __t.string().primaryKey(),
  epoch: __t.u32(),
  season: __t.string(),
  settlementId: __t.u64().name("settlement_id"),
  eventId: __t.u64().name("event_id"),
  x: __t.f32(),
  z: __t.f32(),
  startsAt: __t.timestamp().name("starts_at"),
  endsAt: __t.timestamp().name("ends_at"),
  resolved: __t.bool(),
});
